import type { TextProps } from "./text"
import { Text } from "./text"

type TextPrimaryProps = TextProps

export function TextPrimary({ className, as, ...restProps }: TextPrimaryProps) {
  const newClassName = `text-primary ${className}`
  return <Text className={newClassName} as={as || "span"} {...restProps} />
}
